export default (function (_ref) {
  var colors = _ref.colors;
  return {
    '@global': {
      '.slider': {
        height: function height(_ref2) {
          var _height = _ref2.height;
          return "".concat(_height, "px");
        },
        paddingTop: function paddingTop(_ref3) {
          var height = _ref3.height,
              barHeight = _ref3.barHeight;
          return "".concat((height - barHeight) / 2, "px");
        },
        width: '100%'
      },
      '.handle': {
        width: function width(_ref4) {
          var hasValueInHandler = _ref4.hasValueInHandler,
              handlerWidth = _ref4.handlerWidth,
              height = _ref4.height;
          return "".concat(hasValueInHandler ? handlerWidth : height, "px");
        },
        height: function height(_ref5) {
          var hasValueInHandler = _ref5.hasValueInHandler,
              handlerWidth = _ref5.handlerWidth,
              _height2 = _ref5.height;
          return "".concat(hasValueInHandler ? handlerWidth : _height2, "px");
        },
        position: 'relative'
      },
      '.handle-bars': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: colors.primary,
        borderRadius: '50%',
        boxShadow: '0 1px 3px rgba(0, 0, 0, .25)',
        position: 'absolute',
        top: function top(_ref6) {
          var height = _ref6.height;
          return "".concat(height / 2 * -1, "px");
        },
        marginTop: function marginTop(_ref7) {
          var barHeight = _ref7.barHeight;
          return "".concat(barHeight / 2, "px");
        },
        width: function width(_ref8) {
          var height = _ref8.height;
          return "".concat(height, "px");
        },
        height: function height(_ref9) {
          var _height3 = _ref9.height;
          return "".concat(_height3, "px");
        },
        cursor: 'pointer'
      },
      '.handle.active .handle-bars': {
        backgroundColor: colors.primaryDarker
      },
      '.bar': {
        height: function height(_ref10) {
          var barHeight = _ref10.barHeight;
          return "".concat(barHeight, "px");
        },
        position: 'relative'
      },
      '.bar.bar-0': {
        backgroundColor: colors.primary
      },
      '.bar.bar-1': {
        backgroundColor: '#e4e4e4'
      }
    },
    sliderBarActiveLoanLimit: function sliderBarActiveLoanLimit(_ref11) {
      var barHeight = _ref11.barHeight,
          height = _ref11.height;
      return {
        height: "".concat(barHeight, "px"),
        position: 'absolute',
        top: "".concat((height - barHeight) / 2, "px"),
        backgroundColor: colors.error,
        zIndex: 1,
        pointerEvents: 'none'
      };
    },
    sliderBarDisabled: function sliderBarDisabled(_ref12) {
      var barHeight = _ref12.barHeight,
          height = _ref12.height;
      return {
        height: "".concat(barHeight, "px"),
        position: 'absolute',
        top: "".concat((height - barHeight) / 2, "px"),
        backgroundColor: colors.grayBlue,
        zIndex: 1
      };
    },
    sliderContainer: {
      position: 'relative'
    },
    handlerValue: {
      minWidth: function minWidth(_ref13) {
        var hasValueInHandler = _ref13.hasValueInHandler,
            handlerWidth = _ref13.handlerWidth,
            height = _ref13.height;
        return "".concat(hasValueInHandler ? handlerWidth : height, "px");
      },
      width: 'auto',
      paddingRight: '8px',
      paddingLeft: '8px',
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: '0',
      backgroundColor: colors.white,
      fontWeight: '500',
      border: "1px solid ".concat(colors.inputBorder),
      position: 'relative'
    },
    handleLoanLimit: {
      backgroundColor: "".concat(colors.error, " !important")
    },
    handleDisabled: {
      backgroundColor: colors.grayBlue
    },
    sliderHandleBarsIcon: {
      fill: colors.white,
      textAlign: 'center',
      width: '18px',
      height: '18px'
    },
    valueTooltip: {
      width: 'auto',
      padding: '4px 8px 4px 10px',
      borderRadius: '2px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: '0',
      backgroundColor: colors.white,
      fontWeight: '500',
      boxShadow: '0 2px 16px 0 rgba(0,0,0,0.19)',
      position: 'absolute',
      fontSize: '16px',
      top: '-40px',
      whiteSpace: 'nowrap',
      '&:after': {
        content: '""',
        width: '7px',
        height: '7px',
        background: colors.white,
        position: 'absolute',
        bottom: '-4px',
        left: '50%',
        marginLeft: '-4px',
        transform: 'rotate(45deg)'
      }
    },
    unit: {
      color: colors.monotone2,
      fontSize: '12px'
    }
  };
});